'use client';

import { NavPills } from '@slims/ui/molecules';
import { useAuthStore } from '@/stores/auth-store';
import Link from '@/lib/next/link';
import { usePathname } from '@/lib/next/navigation';

// Platform tools are additional entry points for superadmins only.
const DATA_TABS = [
	{ label: 'CER', href: '/cer' },
	{ label: 'Configurazioni', href: '/configurations' },
	{ label: 'Soci', href: '/members' },
];

export function AdminTabBar() {
	const pathname = usePathname();
	const isSuperadmin = useAuthStore((s) => s.role) === 'superadmin';
	const tabs = [
		...DATA_TABS,
		...(isSuperadmin
			? [
					{ label: 'Dati', href: '/dati' },
					{ label: 'Utenti', href: '/users' },
				]
			: []),
	];
	return (
		<NavPills
			aria-label="Amministrazione"
			linkComponent={Link}
			items={tabs.map((tab) => ({
				...tab,
				active: pathname === tab.href || pathname.startsWith(`${tab.href}/`),
			}))}
		/>
	);
}
